module.exports = {
  base: {
    useUrl: process.env.REACT_APP_USE_URL,
    // useUrl: "https://kjh.wellcomsnt.co.kr/",
    indexedDb: {
      name: "vari-safeway-portal-indexed-db",
    },
  },
  urls: {
    Account: {
      checkId: "api/Account/Check",
      register: "api/Account/Register",
      registerWithCompany: "api/Account/RegisterWithCompany",
      login: "api/Account/GetToken",
      logout: "api/Account/Logout",
      loginEmployee: "api/AccountEmployee/GetTokenEmployeeRequest",
      startLoginSession: "api/AccountEmployee/StartLoginSession/start-login",
      checkSession: "api/AccountEmployee/CheckSession/check-session",
      completeLogin: "api/AccountEmployee/CompleteLoginSession/complete-login",
      checkCompany: "api/Account/CheckCompany",
      refreshToken: "api/AccountEmployee/RefreshToken/refresh",
      getIndustry: "KSICIndustry/SearchIndustry",
    },
    Employee: {
      Upsert: "Employee",
    },
    Common: {
      getCode: "CM10010/DdlCode",
      notAuthGetCode: "CM10010/DdlCodeNotAuth",
      commonCompany: "CommonCompany/Search",
      GetBizSite: "SiteManagement/GetBiz",
      cloudTranslation: "https://translation.googleapis.com/language/translate/v2",
    },
    Sms: {
      notAuthSendMessage: "Sms/SendMessageNotAuth",
    },
    Content: {
      Search: "Content/Search",
      EduSearch: "Content/EduSearch",
      EduViewedList: "Content/EduViewedList",
      Index: "Content/Index",
      Delete: "Content/Delete",
      UploadFile: "Content/UploadFile",
      View: "Content/View",
      EduViewedUpdate: "Content/EduViewedUpdate",
      EduRequst: "Content/EduRequst",
      GetHealthEdu: "Hse",
      FormConfig: "Hse/FormConfig",
      HealthSafety: "Hse/EmployeeHealthSafety",
      MainContentList: "Content/MainContentList",
      Calendar: "EmployeeEdu/CalendarStatus",
    },
    RiskFactor: {
      Availability: "EmployeeEdu/Availability",
      Upsert: "RiskFactor/Upsert",
      RiskFactor: "RiskFactor",
      Search: "RiskFactor/Search",
      SearchByKeyword: "RiskFactor/SearchByKeyword",
      SearchWithTemplate: "RiskFactor/SearchWithTemplate",
      SearchByEmployee: "RiskFactor/SearchByEmployee",
      CompleteRiskFactor: "RiskFactor/CompleteRiskFactor",
      UploadSign: "RiskFactor/UploadSign",
    },
    External: {
      BusinessCheck: "https://api.odcloud.kr/api/nts-businessman/v1/status",
    },
  },
};
